export const PATH_Welcome = '/welcome';
export const PATH_GETTING_STARTED = '/getting-started';
export const PATH_SIGNUP = '/signup';

// export const PATH_HOME = '/home';
export const PATH_LOGIN = '/login';
export const PATH_SIGNOUT = 'signOut';
export const PATH_FORGOT_PASSWORD = '/forgotPassword';
export const PATH_VERIFY_CODE = '/verifycode/:id';
export const PATH_SIGNUP_THANKS = '/signupthanks';
export const PATH_WHATSNEW = '/whatsnew';
export const PATH_SEARCH = '/search';
export const PATH_DASHBOARD = '/dashboard';
export const VILLA_PATH_SEARCH = '/search/:country=:country&villa=:villa&lat=:lat&lng=:lng';
// export const VILLA_PATH_SEARCH = '/propertySearch/:queryParams';

export const PATH_SHUB = '/shub';
export const PATH_MAP = '/map';
export const PATH_CLIENTS = '/clients';
export const PATH_RESERVATIONS = '/reservations';
export const PATH_FAVORITES = '/favorites';
export const PATH_FAVORITES_ADMIN = '/favourites-all';
export const PATH_REPORTS = '/reports';
export const PATH_PROPERTY = '/property';
export const PATH_CALENDAR = '/calendar';
export const PATH_CALENDAR_ID = '/calendar/:id';
export const PATH_PROPERTY_ID = '/property/:id';
export const PATH_LINK = '/link/:linkid';
// Public, token-gated multi-villa offer page (no auth — the token IS the auth).
export const PATH_OFFER = '/offer/:token';
export const PATH_PROPERTY_EDIT = '/propertyEdit';
export const PATH_PROPERTY_CLIENT = '/propertyClient/:id';
export const PATH_PROPERTY_X = '/property/x';
export const PATH_RESERVE = '/reserve';
// Group-accommodation cluster booking (N homes, one linked request).
export const PATH_RESERVE_CLUSTER = '/reserve-cluster';
export const PATH_PROFILE = '/profile';
export const PATH_HOT_DESTINATIONS = '/hotdestinations';
export const PATH_HOT_DESTINATION_DETAIL = '/hotdestinations/:destinationName';
export const PATH_WISH_LIST = '/wishlist';
export const PATH_COLLECTIONS = '/collections';
// One collection, opened in the Search page (pages/Collections/CollectionSearch.js).
export const PATH_COLLECTION = '/collections/:collection';
export const PATH_INTOUCH = '/intouch';
export const PATH_FAQ = '/faq';
export const PATH_ADMIN = '/admin';
export const PATH_DESTINATION_COUNTS = '/destination-counts';
export const PATH_TERMS_CONDITIONS = '/terms-and-conditions';
export const PATH_SEARCH_NEW = '/searchnew'; //By Jaison
export const PATH_RETURN_FLYWIRE = '/request-to-book-flywire';
export const PATH_APPROVE_AGENCY_REDIRECT = '/approve-agency';
export const PATH_DELETE_AGENCY_REDIRECT = '/delete-agency';
export const PATH_DEMO_VIDEOS = '/tutorial-videos';
export const PATH_DATAROOM = '/dataroom';
export const PATH_MEDIA_DIRECTORY = '/media-directory';
export const PATH_MEDIA_DIRECTORY_ADMIN = '/admin/media-directory'; 
export const PATH_ENQUIRIES_ADMIN = '/admin/enquiries';
//  this is to test if on push goes to vercel2..
const constants = {
	// UPSALE / AGENCY_COMMISION removed: both were dead (imported once, never read) and
	// UPSALE's 0.86 was a stale divider that matched no current tier. The markup and the
	// agent's commission now live in Util/pricingPolicy.js — the FE's single source and
	// the twin of VTHub api/services/pricingPolicy.js.
	ENV: 'LOCAL',
	// Bump to force every client to drop its cached destinations list AND bypass the
	// /local/destinations HTTP cache (Cache-Control max-age=86400) on next load —
	// used by pages/index.jsx (localStorage gate) + services/auth.service.js (?v= on
	// the request). Bump whenever the operated-destinations set changes shape.
	DEST_CACHE_VERSION: '5', // v5: destinations_tree carries cities under each region (search-results tree)
	SHUB_URL: 'https://api.villatracker.com',  //https://api.triangle.luxury
	// SHUB_URL: 'http://localhost:3331',
	// VTHUB = SHUB_URL (api.villatracker.com). SHUB (Smiling House) is a SECOND
	// search source; search results from both are merged + deduped in the FE.
	SHUB_SOURCE_URL: 'https://api.triangle.luxury',
	// Kill-switch: set false to instantly revert search to VTHUB-only.
	MERGE_SHUB_SOURCE: true,
	// Merge SHUB+VTHUB on the SERVER (<hub>/local/listings-search-merged) instead
	// of fetching both hubs from the browser and merging here. The server holds
	// both full id lists, so allCount is EXACT and dedupe covers the whole
	// catalogue — the client version could only ever report "rows loaded so far
	// + one window" and dedupe what it had already downloaded.
	// Set false to fall back to the legacy in-browser merge (loadMergedSearch).
	// Once this has run clean in production, delete loadMergedSearch entirely.
	USE_SERVER_MERGE: true,
	// Map viewport (markers + bounds side-list): merge SHub as a source too. Requires SHub
	// (triangle.luxury) to serve the bounds + pointsOnly modes — that port is on SHub master
	// (commit a45f2f4). Enabled now that it's merged; DEPLOY SHUB BEFORE THIS FE, or an
	// un-ported SHub ignores `bounds` and returns whole-world results. Kill-switch: set false.
	MERGE_SHUB_MAP: true,
	// Per-source window fetched for the merged client-side pagination.
	MERGE_WINDOW_SIZE: 48,
	// Unified live-quote endpoint (GET <hub>/api/booking/quote): ONE endpoint for
	// EVERY channel (Guesty/RU/DH/BP/HW/VIB/INV/SH). This is the LIVE path — no env
	// needed. Returns NET; the FE still applies dividerFor() (pricingPolicy), so
	// markup is unchanged. One-line code kill-switch: set to false to revert to the
	// per-PM fan-out.
	USE_UNIFIED_QUOTE: true,
	// Hub credential placeholder for the x-api-key header (Hostaway/BookingPal/RU price
	// previews and the unified /api/booking/*). NOT a key: src/Util/hubSession.js swaps it
	// for `Authorization: Bearer <server-issued hub session>` at request time. Never put a
	// real key here or read one from env — it would ship in the bundle. Asana 1218458529003876.
	SHUB_API_KEY: '__HUB_SESSION__',
	BASE_URL: 'https://backend.villatracker.com',
	// BASE_URL: 'http://localhost:8080',
	// Shared Google Maps browser key. All consumers must keep loading through
	// the SAME loader id ("google-map-script") and key, or useJsApiLoader will
	// try to load the Maps script twice and crash.
	GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || 'AIzaSyDY698B6fgh6O3U49Z5AD_acxX0ekthysA',
	// Flywire classic embedded checkout (FlywirePayment.initiate). 'prod' takes real
	// money; 'demo' is Flywire's sandbox, where test cards work and nothing is charged.
	//
	// SEC-05: REACT_APP_FLYWIRE_ENV is NOT set on Vercel, so THIS LINE IS THE SETTING —
	// there is no environment to correct it in. It read 'demo' for months (a test window
	// that was never reverted), so production checkout ran against the sandbox and nothing
	// on screen said so. Flipped to 'prod' on 2026-09-18, on Praveen's authorisation.
	// Anything other than 'prod' shows the TEST MODE banner on the payment pages
	// (src/components/TestModeBanner), so a future test window cannot be silent again.
	//
	// Normalised once, here, because two places read it and they disagreed about an
	// unrecognised value: the banner hides only on exactly 'prod', while the checkout
	// treated anything but 'demo' as live. A stray 'Prod' or ' prod ' would have shown
	// "no money is taken" while real money moved.
	FLYWIRE_ENV: String(process.env.REACT_APP_FLYWIRE_ENV || 'prod').trim().toLowerCase(), // 'prod' | 'demo'
	// Recipient portal codes are NOT kept here any more (2026-10-27): VT-Backend picks the
	// Flywire account and portal for every checkout (GET /reservation/flywire-checkout,
	// src/Util/flywireCheckout.js), because it is the side that verifies the payment. The
	// Villa Tracker portals (live VWR/VWK/VWL, demo VIE/ADW) are switched on there by env.
	FLYWIRE_CALLBACK_URL: process.env.REACT_APP_FLYWIRE_CALLBACK_URL || 'https://backend.villatracker.com/reservation/flywire-response',
	// Hub credential placeholder for `Authorization: Bearer ${SHUB_STATIC_TOKEN}` on the hub
	// (SHUB_URL / SHUB_SOURCE_URL) calls. NOT a token: src/Util/hubSession.js replaces it with
	// the server-issued session for the hub each request goes to (agent session when logged
	// in, public session otherwise — see src/Util/hubSessionConfig.js). Never put a real token
	// here or read one from env — it would ship in the bundle. Asana 1218458529003876.
	SHUB_STATIC_TOKEN: '__HUB_SESSION__',
	BASE_URL2: 'https://vt-backend-8zwvrrlxf-smiling-house.vercel.app',
	BASE_URL1: 'http://vtbackend-env.eba-b3vxhzrg.us-east-2.elasticbeanstalk.com',
	GLOBAL_ACTION_INIT_STATE: 'GLOBAL_ACTION_INIT_STATE',
	PAGING_PAGE_SIZE: 12,
	PAGING_CLIENT_SIZE: 20,
	PAGING_WISHLIST_SIZE: 10,
	PAGING_AGENCIES_SIZE: 20,
	REACT_APP_STORAGE_SIGNED_USER_KEY: "selfit-frontend-user-data",

	TOAST_TYPE_INFO: 'toast_info',
	TOAST_TYPE_SUCCESS: 'toast_success',
	TOAST_TYPE_WARN: 'toast_warn',
	TOAST_TYPE_ERROR: 'toast_error',
};
 
export default constants;
